export default __webpack_public_path__ + "static/media/17.e967104f.jpg";